import FormattedNumber from './formatted-number';
import formatNumber from './format-number';

export default { FormattedNumber };
export { formatNumber };